import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { BsFileEarmarkPdf } from 'react-icons/bs';
import { authenticatedFetch } from '../../../utils/api';

const VettingReportButton = ({ source, rowId, staffName, className = '' }) => {
    const [loading, setLoading] = useState(false);

    const handleGenerate = async (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (loading || !rowId) return;

        const reportWindow = window.open('', '_blank');
        if (reportWindow) {
            reportWindow.opener = null;
            reportWindow.document.title = 'Generating vetting report';
            reportWindow.document.body.textContent = 'Generating vetting report...';
        }

        setLoading(true);
        try {
            const response = await authenticatedFetch('/ManagerReport/GenerateVettingReport', {
                method: 'POST',
                body: JSON.stringify({ source, rowId }),
            });

            if (!response.ok) {
                const payload = await response.json().catch(() => null);
                throw new Error(payload?.message || 'The vetting report could not be generated.');
            }

            const reportBlob = await response.blob();
            const reportUrl = URL.createObjectURL(reportBlob);
            if (reportWindow) {
                reportWindow.location.replace(reportUrl);
            } else {
                window.open(reportUrl, '_blank', 'noopener,noreferrer');
            }
            window.setTimeout(() => URL.revokeObjectURL(reportUrl), 60000);
        } catch (error) {
            reportWindow?.close();
            window.alert(error.message || 'The vetting report could not be generated.');
        } finally {
            setLoading(false);
        }
    };

    const label = `Generate vetting report${staffName ? ` for ${staffName}` : ''}`;

    return (
        <button
            type="button"
            className={`vetting-report-button ${className}`.trim()}
            onClick={handleGenerate}
            disabled={loading || !rowId}
            aria-label={label}
            title={loading ? 'Generating vetting report...' : label}
        >
            <BsFileEarmarkPdf aria-hidden="true" />
            {loading && <span className="vetting-report-button__spinner" aria-hidden="true" />}
        </button>
    );
};

VettingReportButton.propTypes = {
    source: PropTypes.oneOf([
        'costingShift',
        'costingFutureShift',
        'costingItemLine',
        'fulfilmentShift',
    ]).isRequired,
    rowId: PropTypes.number,
    staffName: PropTypes.string,
    className: PropTypes.string,
};

export default VettingReportButton;
